import React, { useEffect } from 'react';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import unavailable from '../../../../assests/images/unavailable.png';
import theme from '../../../../assests/theme'
import { WeeklyAvailabilityScheduleUtil } from "../../weeklyAvailability"
import { MuiGrid, MuiTypography, MuiEdit, MuiPaper } from '../../../ui/MaterialUIComponents';
import { gradePickerUtil } from '../../gradePicker';
const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
        width:'350px'

    },
}));

export default function TeacherAssignedSubjectComponent(props) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [displaySubjects, setDisplaySubjects] = React.useState(null);
    useEffect(() => {
        getSubjectString(props.assignedSubjects)
    }, []);
    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const getSubjectString = (assignedSubjects) => {
        let displaySubjectsArray = []
        if (assignedSubjects != undefined && assignedSubjects.length > 2) {
            let arrayData = JSON.parse(JSON.stringify(assignedSubjects))
            let assignedSubjectsRemaining = []
            assignedSubjectsRemaining = arrayData.splice(2, arrayData.length - 1)

            assignedSubjectsRemaining.map(function (sub) {
                let subject = {}
                subject.subjectName = sub.subjectName;
                subject.grades = gradePickerUtil.getGradesString(sub.gradeDetails);
                subject.role = sub.isMainTeacher ? "Main Teacher" : "TA";
                subject.preffered = sub.isFixedTeacher ? "Preferred" : "";
                displaySubjectsArray.push(subject)
            })
        }
        return displaySubjectsArray;
    }

    return (
        <div>
            <Typography
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
            >
                {props.subjectName}
            </Typography>
            <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                    paper: classes.paper,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}

                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                {getSubjectString(props.assignedSubjects).map(subject => (
                        <MuiGrid container xs={12}>
                            <MuiGrid item xs={4}>
                                <MuiTypography variant="body2" align='left' gutterBottom>{subject.subjectName}</MuiTypography>
                            </MuiGrid>
                            <MuiGrid item xs={3}>
                                <MuiTypography variant="body2" align='left' gutterBottom>{subject.grades}</MuiTypography>
                            </MuiGrid>
                            <MuiGrid item xs={5}>
                                <MuiTypography variant="body2" align='left' gutterBottom>{subject.preffered + " " + subject.role}</MuiTypography>
                            </MuiGrid>
                        </MuiGrid>
                    ))}
            </Popover>
        </div>
    );
}
